/**
 * Detects if the user is on iOS or Android device
 * @returns 'ios' | 'android' | null
 */
export function detectDevice(): 'ios' | 'android' | null {
  if (typeof window === 'undefined') return null;

  const userAgent = window.navigator.userAgent.toLowerCase();

  // Check for iOS devices (iPhone, iPad)
  const isIOS = /iphone|ipad/.test(userAgent);

  // Check for Android devices
  const isAndroid = /android/.test(userAgent);

  if (isIOS) return 'ios';
  if (isAndroid) return 'android';
  return null;
}

